import React from 'react'
import { Menu, Transition } from '@headlessui/react'

const Dropdown = ({
  align = 'right',
  width = 48,
  contentClasses = 'py-1',
  trigger,
  children,
  noTransition = false
}) => {
  let alignmentClasses

  switch (width) {
    case '48':
      width = 'w-48'
      break
    default:
      break;
  }

  switch (align) {
    case 'left':
      alignmentClasses = 'origin-top-left left-0'
      break
    case 'top':
      alignmentClasses = 'origin-top'
      break
    case 'right-padding':
      alignmentClasses = 'origin-top-right right-3'
      break;
    case 'right':
    default:
      alignmentClasses = 'origin-top-right right-0'
      break
  }

  // Use React portal for the dropdown menu to escape overflow/stacking context
  return (
    <Menu as="div" className="relative">
      {({ open }) => (
        <>
          <Menu.Button as={React.Fragment}>
            {typeof trigger === 'function' ? trigger(open) : trigger}
          </Menu.Button>
          {noTransition ? (
            open && (
              <div style={{isolation: 'isolate'}} className={`absolute z-[999] mt-2 ${width} rounded-md shadow-lg ${alignmentClasses}`}>
                <Menu.Items
                  className={`rounded-md focus:outline-none bg-white dark:bg-slate-800 ${contentClasses}`}
                  static>
                  {children}
                </Menu.Items>
              </div>
            )
          ) : (
            <Transition
              show={open}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-98"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-98"
            >
              {/* Use isolation: isolate and z-[9999] to ensure dropdown is always on top of any content */}
              <div style={{isolation: 'isolate'}} className={`absolute z-[999] mt-2 ${width} rounded-md shadow-lg ${alignmentClasses}`}>
                <Menu.Items
                  className={`rounded-md focus:outline-none bg-white dark:bg-slate-800 ${contentClasses}`}
                  static>
                  {children}
                </Menu.Items>
              </div>
            </Transition>
          )}
        </>
      )}
    </Menu>
  )
}

export default Dropdown
